<template>
  <a-modal title="漏损等级设置" :visible="visible" :width="800" @ok="handleOk" @cancel="handleCancel" :maskClosable="false">
    <div class="leakage-level-setting">
      <div v-for="(item, index) in levelList" :key="index" class="level-item">
        <div class="item-label">漏损等级：</div>
        <a-input v-model="item.name" style="width: 150px" placeholder="请输入等级名称" />

        <div class="color-picker-wrapper">
          <a-popover title="选择颜色" trigger="click" placement="bottom">
            <template slot="content">
              <sketch-picker v-model="item.colorObj" @input="val => updateColor(item, val)" />
            </template>
            <!-- 增加默认颜色，防止 undefined 时不显示 -->
            <div class="color-block" :style="{ backgroundColor: item.color || '#00b42a' }"></div>
          </a-popover>
        </div>

        <div class="rate-label">产销差率：</div>
        <a-input-number v-model="item.min" :min="0" :max="100" :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')" style="width: 100px" />
        <span class="separator">~</span>
        <a-input-number v-model="item.max" :min="0" :max="100" :formatter="value => `${value}%`"
          :parser="value => value.replace('%', '')" style="width: 100px" />

        <div class="action-btn">
          <a-button v-if="index === 0" type="primary" shape="circle" icon="plus" size="small"
            style="background-color: #52c41a; border-color: #52c41a;" @click="addLevel" />
          <a-button v-else type="danger" shape="circle" icon="minus" size="small" @click="removeLevel(index)" />
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
import { Sketch } from 'vue-color'

export default {
  name: 'LeakageLevelModal',
  components: {
    'sketch-picker': Sketch
  },
  data () {
    return {
      visible: false,
      levelList: []
    }
  },
  methods: {
    init () {
      this.visible = true
      // 请求接口获取当前的配置数据
      this.$http.get('/zone-metering/leakage/level/rule').then(({ data }) => {
        if (data && Array.isArray(data)) {
          // 适配返回的数据字段
          this.levelList = data.map(item => {
            const color = item.leakageLevelColor === '1' ? '#FFFFFF' : (item.leakageLevelColor || '#00b42a')
            return {
              ...item,
              name: item.leakageLevel, // 接口字段 leakageLevel
              color: color,
              colorObj: { hex: color }, // 初始化颜色对象给 sketch-picker
              min: item.productionSalesRatioMin, // 接口字段 productionSalesRatioMin
              max: item.productionSalesRatioMax  // 接口字段 productionSalesRatioMax
            }
          })
        }
      }).catch(err => {
        console.error('获取漏损等级设置失败:', err)
        this.$message.error('获取配置失败')
      })
    },
    updateColor (item, val) {
      item.color = val.hex
      item.colorObj = val
    },
    addLevel () {
      this.levelList.push({
        name: '',
        color: '#00b42a', // 默认绿色
        colorObj: { hex: '#00b42a' },
        min: 0,
        max: 0
      })
    },
    removeLevel (index) {
      this.levelList.splice(index, 1)
    },
    handleOk () {
      // 校验数据
      for (const item of this.levelList) {
        if (!item.name) {
          this.$message.warning('请输入漏损等级名称')
          return
        }
        if (item.min === null || item.max === null) {
          this.$message.warning('请输入产销差率范围')
          return
        }
        if (item.min > item.max) {
          this.$message.warning('最小值不能大于最大值')
          return
        }
      }

      // 构造请求参数
      const params = this.levelList.map(item => ({
        ...item,
        leakageLevel: item.name,
        leakageLevelColor: item.color,
        productionSalesRatioMin: item.min,
        productionSalesRatioMax: item.max
      }))

      this.$http.post('/zone-metering/leakage/level/rule', params).then(res => {
        this.$message.success('设置保存成功')
        this.visible = false
        this.$emit('refresh')
      }).catch(err => {
        console.error('保存设置失败:', err)
        this.$message.error('保存失败')
      })
    },
    handleCancel () {
      this.visible = false
    }
  }
}
</script>

<style lang="less" scoped>
.leakage-level-setting {
  padding: 10px;

  .level-item {
    display: flex;
    align-items: center;
    margin-bottom: 15px;
    padding: 10px;
    background-color: #f5f5f5;
    border-radius: 4px;

    .item-label {
      margin-right: 10px;
      width: 70px;
      text-align: right;
    }

    .color-picker-wrapper {
      margin: 0 20px;

      .color-block {
        width: 30px;
        height: 30px;
        border-radius: 2px;
        cursor: pointer;
        border: 1px solid #e8e8e8;
      }
    }

    .rate-label {
      margin-right: 10px;
    }

    .separator {
      margin: 0 10px;
    }

    .action-btn {
      margin-left: 20px;
    }
  }

  .color-palette {
    display: flex;
    flex-wrap: wrap;
    width: 160px;

    .palette-item {
      width: 30px;
      height: 30px;
      margin: 5px;
      border-radius: 2px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        opacity: 0.8;
      }
    }
  }
}
</style>
